module.exports = __webpack_public_path__ + "static/media/FPG_duurzaamheid_02_people.81def3ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sustainable/FPG_duurzaamheid_02_people.jpg
// module id = 770
// module chunks = 0